/**
 * Service API - public list/detail; create used by admin (POST /services).
 * Uses shared api instance and central endpoints.
 */
import api from '../utils/api';
import { ENDPOINTS } from '../config/endpoints';

const { SERVICES } = ENDPOINTS;

export const getServices = (params) => api.get(SERVICES.LIST, { params });
export const getServiceById = (id) => api.get(SERVICES.byId(id));
export const createService = (data) => api.post(SERVICES.LIST, data);
export const updateService = (id, data) => api.put(SERVICES.byId(id), data);
export const deleteService = (id) => api.delete(SERVICES.byId(id));
export const duplicateService = (id) => api.post(SERVICES.duplicate(id));
